import { currentOrigin, currentPathname, getLocal } from './window-utils';

const PATH_PREMIUM = `/_api/premium-store/v1/offering/73988963-5f5f-4f61-b6a1-fd004df31b00`;
const PATH_SITE_LIST = `/_api/sites-list/sites/`;
const PATH_PURCHASE_PACKAGE =
  '/dynamic-offering-checkout-page/purchaseSingleProduct';
const PATH_SUCCESS = 'thanks';
const QUERY_PARAM_MSID = `?msid=`;
const WIX_SUPPORT_URL = `https://support.wix.com`;

export const getPremiumURL = (msid: string) =>
  `${currentOrigin()}${PATH_PREMIUM}${QUERY_PARAM_MSID}${msid}`;

export const getSiteInfoURL = (msid: string) =>
  `${currentOrigin()}${PATH_SITE_LIST}${msid}`;

export const getPurchasePackageURL = () =>
  `${currentOrigin()}${PATH_PURCHASE_PACKAGE}`;

export const getWixPremiumPlans = (msid: string) =>
  `/wix/api/premiumStart?siteGuid=${msid}&referralAdditionalInfo=ascendPP`;

export const getSuccessPageURL = (
  msid: string,
  productId: string,
  cycleUnit: string,
  cycleCount: number,
) => {
  const lastSlashRequired = currentPathname().slice(-1) !== '/' ? '/' : '';
  const successPath = `${currentOrigin()}${currentPathname()}${lastSlashRequired}${PATH_SUCCESS}`;
  return `${successPath}?metaSiteId=${msid}&productId=${productId}&cycleIntervalUnit=${cycleUnit}&cycleIntervalCount=${cycleCount}`;
};

export const getBackPageUrl = (productIndex: number, cycleId: number) => {
  const curUrl = window.location.href;
  return `${curUrl}&productId=${productIndex}&cycleId=${cycleId}`;
};

export const getDashboardURL = (msid: string) =>
  `${currentOrigin()}/dashboard/${msid}/home`;

export const getWixSupportUrl = () => `${WIX_SUPPORT_URL}/${getLocal()}/`;
